/* eslint max-len: ["error", { "code": 120, "tabWidth": 4 }] */
/* eslint-disable node/no-unsupported-features */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Utils} from './Utils';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import {doLogin, resetErrorLogin, requestLogout} from '../actions/login';
import Snackbar from 'material-ui/Snackbar';
import {grey600, red500} from 'material-ui/styles/colors';
import {history} from '../store';
import CircularProgress from 'material-ui/CircularProgress';


import '../css/Home.css';
Utils.init('Home');

export class HomeComponent extends Component {
    static propTypes = {
        login: PropTypes.object.isRequired,
        loginUser: PropTypes.func.isRequired,
        resetError: PropTypes.func.isRequired,
        scratchLoginData: PropTypes.func.isRequired,
        locale: PropTypes.object.isRequired,
        theme: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {username: '', password: '', open: false, message: ''};
    }

    handleLogin = (event) => {
        Utils.log('Home', 'handleLogin');
        event.preventDefault();
        if (this.state.username !== '' && this.state.password !== '') {
            this.props.loginUser(this.state.username, this.state.password);
        } else {
            this.setState({
                open: true,
                message: this.props.locale.messagelogin,
            });
        }
    };

    handleRequestClose = () => {
        this.setState({
            open: false,
        });
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        Utils.log('Home', 'componentWillMount');
        if (this.props.login.logged) {
            history.push('/telomere');
        }
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        Utils.logobj('Home', 'componentWillReceiveProps', nextProps);
        if (nextProps.login.errconn) {
            this.props.resetError();
            this.setState({
                open: true,
                message: this.props.locale.offline,
            });
        } else if (nextProps.login.errlogin) {
            this.props.resetError();
            this.setState({
                open: true,
                message: this.props.locale.errorlogin,
            });
        } else if (nextProps.login.logged) {
            Utils.log('Home', 'componentWillReceiveProps LETSGO');
            history.push('/telomere');
        }
    }

    render() {
        let loginProgress = <div/>;
        if (this.props.login.isFetching) {
            loginProgress =
                <div className="circular-progress">
                    <CircularProgress/>
                </div>;
        }

        return (
            <div className="home-div">
                <form style={{margin: 'auto'}}>
                    <TextField className="login-el" style={{display: 'block'}}
                        hintText={this.props.locale.username}
                        floatingLabelText={this.props.locale.username}
                        floatingLabelStyle={{fontSize: '20px', color: grey600}}
                        floatingLabelFocusStyle={{fontSize: '20px', color: this.props.theme.primaryColor}}
                        onChange={(event) => this.setState({username: event.target.value})}
                        value={this.state.username}
                    />
                    <TextField className="login-el" style={{display: 'block'}}
                        hintText={this.props.locale.password}
                        floatingLabelText={this.props.locale.password}
                        floatingLabelStyle={{fontSize: '20px', color: grey600}}
                        floatingLabelFocusStyle={{fontSize: '20px', color: this.props.theme.primaryColor}}
                        type='password'
                        onChange={(event) => this.setState({password: event.target.value})}
                        value={this.state.password}
                    />
                    <RaisedButton style={{display: 'block', margin: '50px auto', width: '150px'}}
                                  label={this.props.locale.login}
                                  type="submit"
                                  onClick={this.handleLogin}
                    />
                    <div style={{margin: 'auto'}}/>
                    <Snackbar
                        open={this.state.open}
                        message={this.state.message}
                        autoHideDuration={4000}
                        onRequestClose={this.handleRequestClose}
                        bodyStyle={{backgroundColor: red500}}
                    />
                    {loginProgress}
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    login: state.login,
    locale: state.locale.locale,
    theme: state.theme,
});

const mapDispatchToProps = {
    loginUser: doLogin,
    resetError: resetErrorLogin,
    scratchLoginData: requestLogout,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HomeComponent);



// WEBPACK FOOTER //
// ./src/components/Home.js